module.exports = __webpack_public_path__ + "img/workplace.e44e0bfe.png";